/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, ReactNode, useContext, useState } from "react";

type OverlayStateContextValue = {
  settings: boolean;
  toggleSettings: (state: boolean) => void;
};

type OverlayStateProviderProps = {
  children: ReactNode;
};

const OverlayStateContext = createContext<OverlayStateContextValue>(
  {} as OverlayStateContextValue,
);

export const OverlayStateProvider = (props: OverlayStateProviderProps) => {
  const { children } = props;

  const [settings, toggleSettings] = useState<boolean>(false);

  return (
    <OverlayStateContext.Provider value={{ settings, toggleSettings }}>
      {children}
    </OverlayStateContext.Provider>
  );
};

export const useOverlayState = (): OverlayStateContextValue => {
  const context = useContext(OverlayStateContext);

  if (!context) {
    throw new Error("Component beyond OverlayStateContext");
  }

  return context;
};
